/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronUp = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M6.5 12.4L12 8l5.5 4.4-.9 1.2L12 10l-4.5 3.6-1-1.2z" />
	</SVG>
);

export default chevronUp;
